<template>
  <div class="container">
    <div class="common-header-wrap">
      <mt-header title="退款退货" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
    <div class="menu">
      <div @click="$router.push({name:'MemberReturnList'})"><mt-cell class="menu-item" title="退货管理" is-link></mt-cell></div>
      <div @click="$router.push({name:'MemberRefundList'})"><mt-cell class="menu-item" title="退款管理" is-link></mt-cell></div>
      <div @click="$router.push({name:'MemberVrRefundList'})"><mt-cell class="menu-item" title="虚拟退款" is-link></mt-cell></div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
export default {
  components: {
  },
  data () {
    return {
    }
  },
  created () {

  },

  mounted () {

  },
  methods: {

  }
}
</script>
<style scoped lang="scss">

</style>
